import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Data } from "../Data";

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: black;
  color: white;
  padding: 1rem 3rem;
  p {
    font-size: 1rem;
    a {
      font-size: 1rem;
    }
  }
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 4rem;
  }
`;

const FooterLink = styled(Link)`
  color: white;
  text-decoration: none;

  font-size: 1rem;
  &:hover {
    color: lightgray;
  }
`;

const Footer = () => {
  const data = Data;
  return (
    <StyledFooter>
      <p>
        Développé par :{" "}
        <a href="https://www.jcesardesign.com">www.jcesardesign.com</a>
      </p>
      <p>
        © {new Date().getFullYear()} {data.companyName}. Tous droits réservés.
      </p>
      <p>
        <FooterLink to="/legal">Mentions Légales</FooterLink>
      </p>
    </StyledFooter>
  );
};

export default Footer;
